var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8665 15.625C27.6016 15.625 29.0082 14.2259 29.0082 12.5C29.0082 10.7741 27.6016 9.375 25.8665 9.375C24.1314 9.375 22.7249 10.7741 22.7249 12.5C22.7249 14.2259 24.1314 15.625 25.8665 15.625Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8665 28.125C27.6016 28.125 29.0082 26.7259 29.0082 25C29.0082 23.2741 27.6016 21.875 25.8665 21.875C24.1314 21.875 22.7249 23.2741 22.7249 25C22.7249 26.7259 24.1314 28.125 25.8665 28.125Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8665 40.625C27.6016 40.625 29.0082 39.2259 29.0082 37.5C29.0082 35.7741 27.6016 34.375 25.8665 34.375C24.1314 34.375 22.7249 35.7741 22.7249 37.5C22.7249 39.2259 24.1314 40.625 25.8665 40.625Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDots);
export default __webpack_public_path__ + "static/media/more-dots.58097a4b8a97dbc41f47f08d38d964e5.svg";
export { ForwardRef as ReactComponent };